import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReportService, UserService } from '@org/shared-services';
import Chart from 'chart.js/auto';



@Component({
    selector: 'app-task-completion-report',
    imports: [CommonModule, FormsModule],
    templateUrl: './task-completion-report.component.html',
    styleUrls: ['./task-completion-report.component.css']
})
export class TaskCompletionReportComponent implements OnInit {
  startDate: string = '';
  endDate: string = '';
  tasks: any[] = [];
  summaryStats: any = {};
  roles: any[] = []; // Example placeholder for role-based data
  selectedRole: string = ''; // Example role filter
  chart: any = [];

  reportData: any = null;
  isLoading = true;
  error: string | null = null;

  isAccordionOpen = false;
  showResult = false;

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels = ['Total Tasks', 'Completed Tasks', 'On Time Tasks', 'Late Tasks'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [
    { data: [], label: 'Tasks' }
  ];

  constructor( private reportService: ReportService, private userService: UserService ) {}

  ngOnInit(): void {
  //  this.loadReport();
    // this.fetchRoles();
    // this.fetchTasks();
  }

  applyDateRange(): void {
    this.showResult = false;
    if (this.startDate && this.endDate) {
      this.reportService.getTaskCompletionReport(this.startDate, this.endDate)
        .subscribe(res => {
          this.reportData = res.data;
          this.showResult = true;
        });
    }
  }

  fetchRoles(): void {
    // Fetch roles from your API
    this.reportService.fetchRoles().subscribe((response: any) => {
      this.roles = response.roles;
    });
  }

  // Method to get the initials from the name
  getInitials(name: any): string {
    if (!name) return '';
    return this.userService.getInitials(name);
  }

  
  calculateSummaryStats(tasks: any[]): any {
    const totalCompletedTasks = tasks.length;
    const tasksByRole = {}; // Example placeholder
    const tasksByCategory = {}; // Example placeholder
    
    tasks.forEach(task => {
      // Update summary statistics
    });
    
    return {
      totalCompletedTasks,
      tasksByRole,
      tasksByCategory
    };
  }

  toggleAccordion() {
    this.isAccordionOpen = !this.isAccordionOpen;
  }
}
